import i18n from "../i18n";

export const boardTypes = {
  timeline: "timeline",
  week: "week",
  expectedValue: "expectedValue",
  quantitative: "quantitative",
  compareTimeRanges: "compareTimeRanges",
  frequency: "frequency",
  correlation: "correlation",
  network: "network",
  wordcloud: "wordcloud",
  clock: "clock",
  table: "table",
  occurrence: "occurrence",
};

const maxAmountOfQuantitativeLabels = 4;
export const isBoardVisible = (props) => {
  const { quantitativeLabelsChecked, qualitativeLabelsChecked, rom, type } =
    props;
  const quanti = quantitativeLabelsChecked.map(({ id }) => id);
  const quali = qualitativeLabelsChecked.map(({ id }) => id);
  const quantiLength = quanti.length;
  const qualiLength = quali.length;

  const getChoiceLabels = () => {
    const choiceIds = rom?.choiceAnswers.map(({ id }) => id) ?? [];
    return quali.filter((label) => choiceIds.includes(label));
  };
  const getOpenLabels = () => {
    const openIds = rom?.openAnswers.map(({ id }) => id) ?? [];
    return quali.filter((label) => openIds.includes(label));
  };

  const getTimeLabels = () => {
    const timeIds = rom?.timeAnswers.map(({ id }) => id) ?? [];
    return quanti.filter((label) => timeIds.includes(label));
  };

  switch (type) {
    case boardTypes.table:
    case boardTypes.timeline:
    case boardTypes.occurrence:
      return quantiLength > 0 || qualiLength > 0;

    case boardTypes.week:
      return quantiLength > 0 && quantiLength < maxAmountOfQuantitativeLabels;

    case boardTypes.expectedValue:
      // only choice questions are allowed as qualitative label
      return (
        quantiLength > 0 &&
        quantiLength < maxAmountOfQuantitativeLabels &&
        getChoiceLabels().length === 1
      );

    case boardTypes.quantitative:
      return quantiLength > 0;

    case boardTypes.frequency:
      // only choice questions are allowed as qualitative label
      return getChoiceLabels().length === 1;

    case boardTypes.correlation:
      return quantiLength === 2;

    case boardTypes.wordcloud:
      return getChoiceLabels().length > 0 || getOpenLabels().length > 0;

    case boardTypes.clock:
      return getTimeLabels().length > 0;

    case boardTypes.network:
      return quantiLength > 1;

    case boardTypes.compareTimeRanges:
      return quantiLength >= 1;

    default:
      return false;
  }
};

export default function getSettings(board) {
  switch (board.type) {
    case boardTypes.timeline:
      return [
        /*         {
          id: "timeScale",
          edit: true,
          parent: "menu",
          name: i18n.t("moodboards.settings.time"),
          type: "switch",
          value: board.timeScale,
          helpText:
            "The horizontal axis of a timeline chart will be non-linear.",
        }, */
        {
          id: "fullStacked",
          edit: true,
          parent: "menu",
          name: "Stacked",
          type: "switch",
          value: board.fullStacked,
        },
        {
          id: "connectLine",
          edit: true,
          parent: "menu",
          name: "Connect line",
          type: "switch",
          value: board.connectLine,
        },
        {
          id: "smoother",
          edit: true,
          parent: ["header", "footer"],
          type: "timeViewButton",
          value: board.smoother,
        },
        /*  {
           id: "about",
           edit: false,
           parent: "menu",
           name: i18n.t("common.buttons.about"),
           type: "link",
           link: "https://recharts.org/en-US/examples/SimpleLineChart",
         }, */
      ];

    case boardTypes.week:
      return [
        ...barChartSettings(board),
        /*  {
           id: "about",
           edit: false,
           parent: "menu",
           name: i18n.t("common.buttons.about"),
           type: "link",
           link: "https://recharts.org/en-US/examples/TinyBarChart",
         }, */
      ];

    case boardTypes.expectedValue:
      return [
        ...barChartSettings(board),
        /*   {
            id: "about",
            edit: false,
            parent: "menu",
            name: i18n.t("common.buttons.about"),
            type: "link",
            link: "https://recharts.org/en-US/examples/TinyBarChart",
          }, */
      ];

    case boardTypes.quantitative:
      return [
        ...barChartSettings(board),
        /*  {
           id: "about",
           edit: false,
           parent: "menu",
           name: i18n.t("common.buttons.about"),
           type: "link",
           link: "https://recharts.org/en-US/examples/TinyBarChart",
         }, */
      ];

    case boardTypes.frequency:
      return [
        ...barChartSettings(board),
        /*   {
            id: "about",
            edit: false,
            parent: "menu",
            name: i18n.t("common.buttons.about"),
            type: "link",
            link: "https://recharts.org/en-US/examples/TinyBarChart",
          }, */
      ];

    case boardTypes.occurrence:
      return [
        ...barChartSettings(board).filter(
          (setting) => setting.id !== "errorBars" // don't show error bars in occerence board
        ),
      ];

    case boardTypes.correlation:
      return [
        /*     {
              id: "about",
              edit: false,
              parent: "menu",
              name: i18n.t("common.buttons.about"),
              type: "link",
              link: "https://recharts.org/en-US/examples/TinyBarChart",
            }, */
      ];

    case boardTypes.wordcloud:
      return [
        /*   {
            id: "about",
            edit: false,
            parent: "menu",
            name: i18n.t("common.buttons.about"),
            type: "link",
            link: "https://www.npmjs.com/package/react-d3-cloud",
          }, */
      ];

    case boardTypes.clock:
      return [
        {
          id: "clockView",
          edit: false,
          parent: ["footer", "header"],
          type: "clockViewButton",
          value: board.clockView,
        },
      ];

    case boardTypes.table:
      return [
        {
          id: "hideEmptyRows",
          edit: "true",
          parent: "menu",
          name: "Hide empty rows",
          type: "switch",
          value: board.hideEmptyRows,
        },
        /*   {
          id: "pageSize",
          edit: true,
          parent: "",
          name: "Rows per page",
          type: "select",
          value: board.pageSize
        }, */
      ];

    case boardTypes.compareTimeRanges:
      return [
        ...barChartSettings(board),
        /*   {
              id: "about",
              edit: false,
              parent: "menu",
              name: i18n.t("common.buttons.about"),
              type: "link",
              link: "https://recharts.org/en-US/examples/TinyBarChart",
            }, */
      ];

    default:
      return [];
  }
}

const barChartSettings = (board) => [
  {
    id: "errorBars",
    edit: true,
    parent: "footer",
    name: i18n.t("moodboards.settings.error"),
    type: "switch",
    value: board.errorBars,
    showHelp: true,
    helpText:
      "Error bars are graphical representations of the variability of data and used on graphs to indicate the error or uncertainty in a reported measurement.",
    disabled: board.pieChart,
  },
  {
    id: "showValues",
    edit: true,
    parent: "menu",
    name: i18n.t("moodboards.settings.values"),
    type: "switch",
    value: board.showValues,
    helpText: "Show the values above the bars",
  },
  {
    id: "verticalBars",
    edit: true,
    parent: "menu",
    name: i18n.t("moodboards.settings.horizontal"),
    type: "switch",
    value: board.verticalBars,
    helpText: "The rectangular bars are oriented in a horizontal manner.",
    disabled: board.pieChart,
  },
  {
    id: "pieChart",
    edit: true,
    parent: "menu",
    name: i18n.t("moodboards.settings.pieChart"),
    type: "switch",
    value: board.pieChart,
    helpText: "Make a pie chart",
  },
  {
    id: "sortDec",
    edit: true,
    parent: "menu",
    name: i18n.t("moodboards.settings.sortDec"),
    type: "switch",
    value: board.sortDec,
    helpText: "Sort the values decending",
  },
];
